<template>
  <section class="assisted-brands">
    <div class="container">
      <!-- Title  -->
      <h1 class="title">Centro Assistenza Autorizzato</h1>

      <!-- Text  -->
      <p class="paragraph d-none d-lg-block">
        I marchi per cui siamo autorizzati a fornire assistenza, operiamo sia su
        impianti civili che industriali
      </p>

      <!-- Brands List  -->
      <ul
        class="brands-list row row-cols-2 row-cols-lg-3 justify-content-center"
      >
        <li
          class="col brand-logo"
          v-for="(brand, i) in assistedBrands"
          :key="i"
        >
          <div class="wrapper">
            <img
              :src="require(`../assets/images/${brand.name}-logo.png`)"
              :alt="`${brand.name}-logo`"
            />
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "AssistedBrands",
  data: function () {
    return {
      assistedBrands: [
        {
          name: "lg",
        },
        {
          name: "mitsubishi-electric",
        },
        {
          name: "samsung",
        },
        {
          name: "hitachi",
        },
        {
          name: "olimpia-splendid",
        },
        {
          name: "midea",
        },
        {
          name: "hisense",
        },
        {
          name: "fantinicosmi",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.assisted-brands {

  .container {
    .brands-list {
      align-items: center;

       @media screen and (min-width: 992px) {
          margin-top: 5rem;
        }

      .brand-logo {
        margin-bottom: 3.8rem;

        &:nth-child(7), &:last-child {
          margin-bottom: 0;
        }

        @media screen and (min-width: 992px) {
          margin-bottom: 5rem;
        }

        .wrapper {
          min-width: 110px;
          width: 55%;
          margin: auto;

          @media screen and (min-width: 992px) {
            width: 45%;
          }
        }
      }
    }
  }
}
</style>
